import $http from "../../utils/$http";
import { useRequest } from "../../utils/initInstance";
const { post, get } = $http;
export default {
  addFeedback: (params) =>
    useRequest("/product/feedback/add", params, { method: "post" }), // 添加产品留咨
  getBannerList: (params) =>
    useRequest("/banner/list", params, { method: "get" }), // 广告Banner
  getProductCategoryList: (params) =>
    useRequest("/product-category/list", params, { method: "get" }), // 产品分类
  getProductList: (params) =>
    useRequest("/product/list", params, { method: "get" }), // 产品列表
  getProductDetail: (params) =>
    useRequest("/product/getDetail", params, { method: "get" }), // 产品详情
  getProductSelect: (params) =>
    useRequest("/product-category/select", params, { method: "get" }), // 留资选择
  getQueryMainProductList: (params) =>
    useRequest("/product/queryMainProductList", params, { method: "get" }), // 主推产品
  getSelectOneByPageName: (params) =>
    useRequest("/product/page-config/selectOneByPageName", params, { method: "get" }), // 获取页面内容
};
